import React from 'react';
import { useTranslation } from 'react-i18next';

const ExistingTermsOfService = () => {
    const { t } = useTranslation();

    return (
        <div className="prose prose-invert max-w-none">
            <h1 className="text-center">{t('termsOfService.title')}</h1>
            <p className="text-sm text-center text-red-400 font-bold">{t('termsOfService.disclaimer')}</p>

            <h2>{t('termsOfService.acceptance.title')}</h2>
            <p>{t('termsOfService.acceptance.content')}</p>

            <h2>{t('termsOfService.userAccounts.title')}</h2>
            <p>{t('termsOfService.userAccounts.content')}</p>

            <h2>{t('termsOfService.inAppCurrency.title')}</h2>
            <p>{t('termsOfService.inAppCurrency.description')}</p>
            <ul>
                <li><strong>{t('termsOfService.inAppCurrency.noRealWorldValue.title')}</strong> {t('termsOfService.inAppCurrency.noRealWorldValue.content')}</li>
                <li><strong>{t('termsOfService.inAppCurrency.allPurchasesFinal.title')}</strong> {t('termsOfService.inAppCurrency.allPurchasesFinal.content')}</li>
                <li><strong>{t('termsOfService.inAppCurrency.cashOutFeature.title')}</strong> {t('termsOfService.inAppCurrency.cashOutFeature.content')}</li>
                <li><strong>{t('termsOfService.inAppCurrency.fraud.title')}</strong> {t('termsOfService.inAppCurrency.fraud.content')}</li>
            </ul>

            <h2>{t('termsOfService.chargebacks.title')}</h2>
            <p>{t('termsOfService.chargebacks.content')}</p>

            <h2>{t('termsOfService.userContent.title')}</h2>
            <p>{t('termsOfService.userContent.content')}</p>

            <h2>{t('termsOfService.prohibitedConduct.title')}</h2>
            <p>{t('termsOfService.prohibitedConduct.description')}</p>
            <ul>
                <li>{t('termsOfService.prohibitedConduct.harassing')}</li>
                <li>{t('termsOfService.prohibitedConduct.illegalContent')}</li>
                <li>{t('termsOfService.prohibitedConduct.illegalPurpose')}</li>
                <li>{t('termsOfService.prohibitedConduct.interference')}</li>
            </ul>

            <h2>{t('termsOfService.intellectualProperty.title')}</h2>
            <p>{t('termsOfService.intellectualProperty.content')}</p>

            <h2>{t('termsOfService.disclaimers.title')}</h2>
            <p>{t('termsOfService.disclaimers.content')}</p>

            <h2>{t('termsOfService.governingLaw.title')}</h2>
            <p>{t('termsOfService.governingLaw.content', { state: '[Your State]', city: '[Your City]' })}</p>
        </div>
    );
};

export default ExistingTermsOfService;
